import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { HostConfigService } from '@/common/host-config/host-config.service';

@Injectable({
	providedIn: 'root',
})
export class CustomHostRouteGuard {
	private readonly hostConfig = inject(HostConfigService);
	private readonly router = inject(Router);
	private readonly platformId = inject(PLATFORM_ID);

	canActivate(): boolean | UrlTree {
		if (this.hostConfig.showFullNav()) {
			return true;
		}
		const baseUrl = this.hostConfig.baseUrl();
		if (isPlatformBrowser(this.platformId)) {
			window.location.href = baseUrl;
			return false;
		}
		return this.router.createUrlTree(['/']);
	}
}
